import { Component, Input, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'am-places-autocomplete-scroll-controls',
  templateUrl: './scroll-controls.component.html',
  styleUrls: ['./scroll-controls.component.scss'],
  standalone: false,
})
export class ScrollControlsComponent {
  @Input() disableUp = false;
  @Input() disableDown = false;

  @Output() scrollUp = new EventEmitter<void>();
  @Output() scrollDown = new EventEmitter<void>();
}
